import { CSSProperties } from 'react';

import { Div, Loader as TeliaLoader, SupportedLoaderSizes } from '@gaiads/telia-react-component-library';
import { PaddingProps } from '@gaiads/telia-react-component-library/build/types/components/Element/getPaddingClasses';

interface LoaderProps {
  size?: SupportedLoaderSizes;
  padding?: PaddingProps;
  style?: CSSProperties;
}

export const Loader = ({ padding = { top: 'xlg' }, size = 'lg', style = { width: '100%' } }: LoaderProps) => {
  return (
    <Div alignTextToCenter padding={padding} style={style} data-testid="loader">
      <TeliaLoader size={size} />
    </Div>
  );
};
